'use strict'
import angular from 'angular'

angular.module('tasksFilter').factory('TasksFilterDefaultOptionsProvider', [
    'InstanceSettings',
    function (InstanceSettings) {
        let defaultValues = null

        return {
            optionsForField: [
                {value: 'line_item_start', label: 'Line Item Start Date'},
                {value: 'line_item_end', label: 'Line Item End Date'},
                {value: 'task_created_date', label: 'Task Creation Date'},
                {value: 'due_date', label: 'Task Due Date'}
            ],

            optionsForComparator: [
                {value: 'e', label: '='},
                {value: 'g', label: '>'},
                {value: 'ge', label: '> or ='},
                {value: 'se', label: '< or ='},
                {value: 's', label: '<'}
            ],

            defaultValues(callback) {
                if (defaultValues) {
                    callback(defaultValues)
                }

                InstanceSettings.getTasksAssignmentsDefaultFilterValue(function (filter) {
                    let parts = filter.split(':')

                    defaultValues = {
                        field: parts[0],
                        comparator: parts[1],
                        boundary: parts[2]
                    }

                    callback(defaultValues)
                }, function () {
                    callback({})
                })
            }
        }
    }
])